import { writable } from 'svelte/store';

import { SyncService } from '@client/services/sync';

export function getKey(endpoint) {
  switch (endpoint) {
    case 'groups':
      return 'name';
    case 'organizations':
      return 'name';
    default:
      return 'email';
  }
}
const createSyncStore = () => {
  const { subscribe, update } = writable({
    failures: 0,
    syncing: false,
    syncResults: [],
    successes: 0,
    error: null
  });

  const reset = () => {
    update((state) => ({ ...state, syncing: false, syncResults: [], successes: 0, failures: 0, error: null }));
  };

  const sync = async (payload, endpoint, scope) => {
    update((state) => ({ ...state, syncing: true, syncResults: [], successes: 0, failures: 0, error: null }));

    const key = getKey(scope);
    const pattern = `{${key}}`;

    return new Promise((resolve, reject) => {
      SyncService.streamSync(endpoint, scope, payload, pattern)
        .node(pattern, (node) => {
          update((state) => {
            const success = node.status === 'synced';
            return {
              ...state,
              syncResults: [...state.syncResults, { name: node[key], success }],
              successes: success ? state.successes + 1 : state.successes,
              failures: success ? state.failures : state.failures + 1
            };
          });
        })
        .done(() => {
          let finalState;

          update((state) => {
            finalState = { ...state, syncing: false };
            return finalState;
          });

          resolve(finalState);
        })
        .fail((error) => {
          update((state) => ({
            ...state,
            syncing: false,
            error: error?.jsonBody?.message || error?.message || 'Sync failed'
          }));
          reject(error);
        });
    });
  };

  return {
    reset,
    subscribe,
    sync
  };
};

export const syncStore = createSyncStore();
